import _ from 'lodash';

function reducer(state = [], action) {
  let index = 0;
  switch (action.type) {
    case 'ADJUSTMENTS/ZIP/SET':
      return action.adjustments;
    case 'ADJUSTMENTS/ZIP/CLEAR':
      return null;
    case 'ADJUSTMENTS/ZIP/UPDATE':
      index = _.findIndex(state, program => { return program.IdZipCodeGroup === action.program.IdZipCodeGroup });
      return [...state.slice(0, index), action.program, ...state.slice(index + 1)];
    case 'DIVISION/REMOVE_ZIPCODE':
      action.program.divisions = _.reject(action.program.divisions, (d) => { return d.IdDivision === action.division.IdDivision });
      // Update the store
      index = _.findIndex(state, program => { return program.IdZipCodeGroup === action.program.IdZipCodeGroup });
      return [...state.slice(0, index), action.program, ...state.slice(index + 1)];
    default:
      return state;
  }
}

export default reducer;